import * as React from "react"
import trans from "trans"

import {
    Grid,
    GridCell,
    css,
    Icon,
    Theme,
} from "@bdfx/mergado-ui-kit"

import {
    FilterIsOpenType,
    FilterIsOpenTypes,
} from "./filters";

import {iconDisabledColor} from "template-edit/components/tools-panel";
import WatermarksFilters from "./watermarks-filters";
import QualityFilters from "./quality-filters";
import ValidationsFilters from "./validations-filters";
import BackgroundFilters from "./background-filters";
import ImageFilters from "./image-filters";
import ProductFilters from "./product-filters";
import SizeFilters from "./size-filters";
import ElementsFilters from "./elements-filters";
export type MinMaxType = {from: number, to: number, label: string, value: string}
export type ColorModelType = {label: string, value: number}

interface Props {
    setIsDirty: Function
    userId: number
    verticalMode: boolean
    openedFilters: FilterIsOpenType[]
    nonEmptyFilters: FilterIsOpenType[]
    toggleFilterIsOpen: Function
}

class BasicFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    renderSeparator = (type: FilterIsOpenType) => {
        const {openedFilters, nonEmptyFilters} = this.props

        const isOpened = openedFilters.includes(type)
        const isNotEmpty = nonEmptyFilters.includes(type)

        return <GridCell key={type} className={'filter-separator clickable'} onClick={() => this.props.toggleFilterIsOpen(type)}>
            <Icon type={isOpened ? 'chevron-down-light' : 'chevron-right-light'} text={trans(type)} color={isNotEmpty ? Theme.steelblue : '#3a3a3a'} size={20} />
        </GridCell>
    }

    renderFilterByType = (type: FilterIsOpenType) => {
        const {userId} = this.props

        switch(type) {
            case "product":
                return <ProductFilters setIsDirty={this.props.setIsDirty} userId={userId}/>
            case "image":
                return <ImageFilters setIsDirty={this.props.setIsDirty} userId={userId} />
            case "background":
                return <BackgroundFilters setIsDirty={this.props.setIsDirty} userId={userId}/>
            case "size_format":
                return <SizeFilters setIsDirty={this.props.setIsDirty} />
            case "product_elements":
                return <ElementsFilters setIsDirty={this.props.setIsDirty} />
            case "validations":
                return <ValidationsFilters setIsDirty={this.props.setIsDirty} />
            case "watermarks":
                return <WatermarksFilters setIsDirty={this.props.setIsDirty} userId={userId} />
            case "images_quality":
                return <QualityFilters setIsDirty={this.props.setIsDirty} />
            default:
                return <React.Fragment/>
        }
    }

    render() {
        const {verticalMode, openedFilters} = this.props

        return (
            <StyledMainFilters dataIsVerticalMode={verticalMode}>
                <Grid cols={`repeat(auto-fit, minmax(${verticalMode ? 180 : 200}px, 1fr))`} gap={'5px'}>
                    {FilterIsOpenTypes.map((type: FilterIsOpenType) => {
                            return <React.Fragment key={`filter-${type}`}>
                                {verticalMode &&
                                this.renderSeparator(type)
                                }

                                {openedFilters.includes(type) &&
                                this.renderFilterByType(type)
                                }
                            </React.Fragment>
                        })
                    }
                </Grid>
            </StyledMainFilters>
        )
    }
}

const StyledMainFilters = css('div')({
    ' .two-columns': {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridGap: '5px',
        ' .muk-gridcell': {
            paddingLeft: 0,
            paddingRight: '10px',
            borderLeft: 'none',
        },
    },
    ' .muk-form-group': {
        marginBottom: '10px',
    },
    ' input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        ' -webkit-appearance': 'none',
        margin: 0,
    },
    ' input[type=number]': {
        ' -moz-appearance': 'textfield',
    },
    ' .autocomplete-icon-text .muk-icon__text': {
        color: '#000 !important',
    },
    ' .template-inactive': {
        textDecoration: 'line-through',
        fontStyle: 'italic',
        color: iconDisabledColor,
    },
}, (props) => {
    return {
        ' .muk-gridcell': {
            paddingLeft: props.dataIsVerticalMode ? '15px' : undefined,
            borderLeft: props.dataIsVerticalMode ? `2px solid #99b3c5` : undefined,
        },
        ' .filter-separator': {
            color: '#3a3a3a',
            textTransform: 'uppercase',
            marginBottom: props.dataIsVerticalMode ? '5px' : undefined,
            marginTop: props.dataIsVerticalMode ? '15px' : undefined,
            paddingLeft: props.dataIsVerticalMode ? 0 : undefined,
            marginLeft: '-5px',
            border: 0,
        }
    }
})

export default BasicFilters
